import type { ReactNode } from 'react';
import { Loading } from './Loading';

export interface PageLoadingProps {
    /** Text displayed below the spinner (only used when no children are provided) */
    description?: string;
    /** Custom content that replaces the default spinner. Auth screens use this
     *  to render their own status cards with PuffLoader inside. */
    children?: ReactNode;
}

/**
 * Full-page loading screen with background and responsive centering.
 *
 * Preserves the responsive layout from ComponentLoading:
 * - Mobile: content top-aligned (`justify-start`)
 * - Desktop: content centred (`md:justify-center`)
 *
 * When `children` are provided, they replace the default spinner entirely.
 * This matches how auth screens pass their own custom status cards.
 */
export const PageLoading = ({ description, children }: PageLoadingProps) => {
    return (
        <div className="relative flex min-h-full w-screen flex-col justify-start bg-background md:justify-center">
            {children ?? <Loading size="large" description={description} />}
        </div>
    );
};

PageLoading.displayName = 'PageLoading';
